export const vesselUpdatesConstants = {
    VESSEL_UPDATES_FETCHING: 'VESSEL_UPDATES_FETCHING',
    VESSEL_UPDATES_FETCHED: 'VESSEL_UPDATES_FETCHED',
    VESSEL_UPDATES_SUBMITTING: 'VESSEL_UPDATES_SUBMITTING',
    VESSEL_UPDATES_SUBMITTED: 'VESSEL_UPDATES_SUBMITTED',
    GET_VESSEL_HEADER_DETAILS_BY_VUID: 'GET_VESSEL_HEADER_DETAILS_BY_VUID',
    VESSEL_UPDATES: 'VESSEL_UPDATES',
    CREATE_VESSEL_DETAILS: 'CREATE_VESSEL_DETAILS'
}